import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePostV1IndividualsByIndividualIdRegenerate } from '../client/queries'
import { REGEN_INVALIDATION_KEYS } from './regen-invalidation'

export const useTriggerRegen = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdRegenerate({
    onSuccess: () => {
      for (const key of REGEN_INVALIDATION_KEYS) {
        queryClient.invalidateQueries({ queryKey: [key] })
      }
    },
  })
}
